"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Loader = _interopRequireDefault(require("../../general/Loader"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Button');
var LOADER_SIZES = {
  big: 'small',
  medium: 'tiny',
  small: 'mini'
};

function Button(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      onClick = _ref.onClick,
      size = _ref.size,
      type = _ref.type,
      color = _ref.color,
      isDisabled = _ref.isDisabled,
      isFullWidth = _ref.isFullWidth,
      isLoading = _ref.isLoading,
      href = _ref.href,
      target = _ref.target,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "onClick", "size", "type", "color", "isDisabled", "isFullWidth", "isLoading", "href", "target"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Button.overrides); // Classes

  var rootClassName = (0, _classnames3.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes[type], type), (0, _defineProperty2.default)(_classnames, classes.white, !color), (0, _defineProperty2.default)(_classnames, classes.primary, color === 'primary'), (0, _defineProperty2.default)(_classnames, classes.danger, color === 'danger'), (0, _defineProperty2.default)(_classnames, classes.grey, color === 'grey'), (0, _defineProperty2.default)(_classnames, classes.small, size === 'small'), (0, _defineProperty2.default)(_classnames, classes.big, size === 'big'), (0, _defineProperty2.default)(_classnames, classes.disabled, isDisabled || isLoading), (0, _defineProperty2.default)(_classnames, classes.fullWidth, isFullWidth), _classnames), classNameProp);
  var wrapperLabelClass = (0, _classnames3.default)((0, _defineProperty2.default)({}, classes.labelLoading, isLoading));
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName,
    onClick: isDisabled || isLoading ? null : onClick
  });

  var content = /*#__PURE__*/_react.default.createElement("span", {
    className: wrapperLabelClass
  }, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loader
  }, /*#__PURE__*/_react.default.createElement(_Loader.default, (0, _extends2.default)({
    size: LOADER_SIZES[size],
    color: ['outlined', 'squared-outlined'].includes(type) ? color : 'white'
  }, override.Loader))), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.Text
  }, override.Text), children));

  if (href) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      href: href,
      target: target
    }, rootProps, override.root), content);
  } else {
    return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, rootProps, {
      type: "button"
    }, override.root), content);
  }
}

Button.overrides = ['root', 'Text', 'Loader'];
Button.defaultProps = {
  size: 'medium',
  type: 'filled',
  overrides: {}
};
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onClick: _propTypes.default.func,
  children: _propTypes.default.node.isRequired,
  size: _propTypes.default.oneOf(['big', 'medium', 'small']),
  type: _propTypes.default.oneOf(['filled', 'outlined', 'squared', 'squared-outlined']),
  color: _propTypes.default.oneOf(['primary', 'danger', 'white', 'grey']),
  isDisabled: _propTypes.default.bool,

  /** Use the whole container */
  isFullWidth: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,

  /** Render the component as a tag <a/> with href */
  href: _propTypes.default.string,

  /** native <a/> target */
  target: _propTypes.default.string
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Button);

exports.default = _default;